import { useFormState } from 'react-hook-form'
import { FormDirtyBlocker } from '@editorComponents'
import { checkSettingsBlockAction, CheckSettingsSectionKey } from '../constants'
import { CheckSettingsFormValues } from '../types'

interface Props {
  /** Distinguishes this section's block from the other tabs', e.g. 'hotDimensioning'. */
  sectionKey: CheckSettingsSectionKey
  /**
   * Keys within `sharedSettings` to ignore when deciding whether the section is
   * dirty — for bookkeeping fields (e.g. supportCompression's excludedSupports /
   * irrelevantSupports) that never enable Save on their own and so must not
   * block navigation on their own either.
   */
  ignoreDirtyFields?: string[]
}

/**
 * Registers a block while the staged settings have unsaved changes, so switching
 * to another Nachweiseinstellungen tab — which unmounts this form — is refused
 * instead of silently discarding them. Renders nothing; must live inside the form.
 */
const CheckSettingsDirtyBlocker = <SharedSettings = SettingsOnMember,>({
  sectionKey,
  ignoreDirtyFields,
}: Props): JSX.Element => {
  const { dirtyFields } = useFormState<CheckSettingsFormValues<SharedSettings>>()

  const sharedSettingsDirtyFields = dirtyFields.sharedSettings as
    | Record<string, unknown>
    | undefined
  const isDirty = ignoreDirtyFields
    ? Object.keys(sharedSettingsDirtyFields ?? {}).some(key => !ignoreDirtyFields.includes(key))
    : !!sharedSettingsDirtyFields

  return <FormDirtyBlocker actionId={checkSettingsBlockAction(sectionKey)} isDirty={isDirty} />
}

export default CheckSettingsDirtyBlocker
